'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherAlertTriangle, FeatherExternalLink } from '@subframe/core';
import { Button } from '@/shared/components/ui';
import { formatDataPrazo } from '@/shared/formatters';
import type { AutorizacaoArEnvio } from '@/types/arbitral/envioArTypes';
interface AutorizacaoArBannerProps {
  envio: AutorizacaoArEnvio;
  vencido: boolean;
  /** Decisão desta solicitação já no ar — a faixa não pode disparar a segunda. */
  acaoEmVoo: boolean;
  onResolver: () => void;
}

/**
 * Faixa no topo do processo para a autorização não depender de o requerente rolar até a Visão
 * geral — a citação fica parada enquanto ele não decide.
 */
export function AutorizacaoArBanner(t0) {
  const $ = _c(27);
  const {
    envio,
    vencido,
    acaoEmVoo,
    onResolver
  } = t0;
  const conveniado = envio.cobranca === "CONVENIO";
  const acaoDaFaixa = conveniado ? "AUTORIZAR" : "PAGAR";
  if (envio.estado !== "AGUARDANDO_AUTORIZACAO") {
    return null;
  }
  if (!envio.acoes.includes(acaoDaFaixa)) {
    return null;
  }
  const t1 = `flex w-full flex-wrap items-center gap-3 rounded-[16px] border border-solid px-4 py-3 ${vencido ? "border-error-200 bg-error-50" : "border-warning-200 bg-warning-50"}`;
  const t2 = `h-5 w-5 flex-none ${vencido ? "text-error-600" : "text-warning-600"}`;
  let t3;
  if ($[0] !== t2) {
    t3 = <FeatherAlertTriangle className={t2} />;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = `text-body-bold font-body-bold ${vencido ? "text-error-900" : "text-warning-900"}`;
  const t5 = vencido ? "Prazo para autorizar o envio de AR venceu" : "Envio de AR aguardando sua autoriza\xE7\xE3o";
  let t6;
  if ($[2] !== t4 || $[3] !== t5) {
    t6 = <span className={t4}>{t5}</span>;
    $[2] = t4;
    $[3] = t5;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  const t7 = `text-caption font-caption ${vencido ? "text-error-700" : "text-warning-700"}`;
  const t8 = `A citação de ${envio.requeridoNome} continua assim que você autorizar`;
  let t9;
  if ($[5] !== envio.prazoAutorizacaoEm || $[6] !== vencido) {
    t9 = envio.prazoAutorizacaoEm ? ` · ${vencido ? "venceu" : "vence"} em ${formatDataPrazo(envio.prazoAutorizacaoEm)}` : "";
    $[5] = envio.prazoAutorizacaoEm;
    $[6] = vencido;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  let t10;
  if ($[8] !== t7 || $[9] !== t8 || $[10] !== t9) {
    t10 = <span className={t7}>{t8}{t9}</span>;
    $[8] = t7;
    $[9] = t8;
    $[10] = t9;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== t10 || $[13] !== t6) {
    t11 = <div className="flex min-w-[220px] flex-1 flex-col">{t6}{t10}</div>;
    $[12] = t10;
    $[13] = t6;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== conveniado) {
    t12 = conveniado ? undefined : <FeatherExternalLink />;
    $[15] = conveniado;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  const t13 = conveniado ? "Autorizar envio" : "Autorizar e pagar";
  let t14;
  if ($[17] !== acaoEmVoo || $[18] !== onResolver || $[19] !== t12 || $[20] !== t13) {
    t14 = <Button variant="brand-primary" size="medium" iconRight={t12} disabled={acaoEmVoo} onClick={onResolver}>{t13}</Button>;
    $[17] = acaoEmVoo;
    $[18] = onResolver;
    $[19] = t12;
    $[20] = t13;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== t1 || $[23] !== t11 || $[24] !== t14 || $[25] !== t3) {
    t15 = <div className={t1}>{t3}{t11}{t14}</div>;
    $[22] = t1;
    $[23] = t11;
    $[24] = t14;
    $[25] = t3;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  return t15;
}